import {SelectPickerOption} from "./select-picker-option";

export type UserProfileType = 'ADMCONTA' | 'Financial' | 'GeneralInquirer' | 'Inquirer';
export const ProfileSelectOptions: SelectPickerOption[] = [
    {label: 'Administrador', value: 'ADMCONTA'},
    {label: 'Financeiro', value: 'Financial'},
    {label: 'Consultor', value: 'GeneralInquirer'},
    {label: 'Consultor Individual', value: 'Inquirer'},
];